import { Alert, Skeleton } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { CreateFormProps } from '../../../../types/scorecardTypes';
import { QuestionsSubForm } from './QuestionsSubForm';
import { TemplateSelect } from './TemplateSelect';
import { useQueryGetAvailableScorecardsByRoleData } from 'features/Connect/features/ConnectATSIntegration/api/scorecardQueries';
import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { getAxiosErrorMessageByStatusCode } from 'hooks/errorHandling/errorHandlingHooks';

export const CreateForm: React.FC<CreateFormProps> = ({ roleId }) => {
  const { watch } = useFormContext();
  const {
    data: scorecards,
    isLoading,
    isError,
    error,
  } = useQueryGetAvailableScorecardsByRoleData(roleId);
  const errorMessage = getAxiosErrorMessageByStatusCode(error);
  const id = watch('custom_scorecard_id');
  const selectedScorecard = scorecards?.find((scorecard) => scorecard.id === id);

  if (isLoading) {
    return (
      <Skeleton
        data-testid={ATSConnectHiringRequestCreateFeedbackTestIds.SELECT_LOADING_SKELETON}
        variant="rectangular"
        height={53}
      />
    );
  }

  if (isError) {
    return <Alert severity="error">{errorMessage}</Alert>;
  }

  return (
    <>
      <TemplateSelect scorecards={scorecards} />
      {selectedScorecard && (
        <QuestionsSubForm
          questions={selectedScorecard.questions}
          scorecardTitle={selectedScorecard.title}
        />
      )}
    </>
  );
};
